import { render } from "./activeity-item.vue?vue&type=template&id=22b112da&scoped=true&ts=true"
import script from "./activeity-item.vue?vue&type=script&lang=tsx"
export * from "./activeity-item.vue?vue&type=script&lang=tsx"

import "./activeity-item.vue?vue&type=style&index=0&id=22b112da&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b112da"]])

export default __exports__